var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricPlatform(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#FDEFFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#FEFAFE",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.5366 27.6391C21.0315 27.2564 17.5997 27.2564 14.0946 27.6391",
    stroke: "#BC73BC",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9425 20.8074C27.7489 22.1695 26.6466 23.2289 25.3026 23.3502C21.2638 23.7148 17.3577 23.7148 13.319 23.3502C11.9749 23.2289 10.8726 22.1695 10.6791 20.8074C10.2831 18.0204 10.2831 15.3851 10.6791 12.5981C10.8726 11.236 11.9749 10.1766 13.319 10.0553C17.3577 9.6908 21.2638 9.6908 25.3026 10.0553C26.6466 10.1766 27.7489 11.236 27.9425 12.5981C28.3385 15.3851 28.3385 18.0204 27.9425 20.8074Z",
    fill: "#F2D8F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9425 20.8074C27.7489 22.1695 26.6466 23.2289 25.3026 23.3502C21.2638 23.7148 17.3577 23.7148 13.319 23.3502C11.9749 23.2289 10.8726 22.1695 10.6791 20.8074C10.2831 18.0204 10.2831 15.3851 10.6791 12.5981C10.8726 11.236 11.9749 10.1766 13.319 10.0553C17.3577 9.6908 21.2638 9.6908 25.3026 10.0553C26.6466 10.1766 27.7489 11.236 27.9425 12.5981C28.3385 15.3851 28.3385 18.0204 27.9425 20.8074Z",
    stroke: "#BC73BC",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5031 23.5868C20.0402 23.6359 18.5839 23.6359 17.121 23.5866L16.4371 27.4396C18.3578 27.3228 20.2661 27.3226 22.1867 27.439L21.5031 23.5868Z",
    stroke: "#BC73BC",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4535 14.1147C21.4535 14.1147 23.5963 15.9236 23.5963 16.7027C23.5963 17.4818 21.4535 19.2907 21.4535 19.2907",
    stroke: "#BC73BC",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1678 14.1147C17.1678 14.1147 15.0249 15.9236 15.0249 16.7027C15.0249 17.4818 17.1678 19.2907 17.1678 19.2907",
    stroke: "#BC73BC",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricPlatform);
export default __webpack_public_path__ + "static/media/MetricPlatform.1a44c0cfbfd8dfb3ccbb4f6fb04fc3bf.svg";
export { ForwardRef as ReactComponent };